import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { UserProfileManagement } from "../../modules/user-profile-management";
import TenantContextBanner from "../../components/common/TenantContextBanner";
import useAuth from "../../hooks/useAuth";

const UserProfilesPage = () => {
  const { isTenantUser, isSystemUser, activeTenantId } = useAuth();
  const location = useLocation();
  const isTenantScope =
    isTenantUser || location.pathname.startsWith("/tenant-");

  // User Profile APIs are tenant-scoped.
  if (isSystemUser && !isTenantScope) {
    return <Navigate to="/dashboard" replace />;
  }

  if (isSystemUser && isTenantScope && !activeTenantId) {
    return <Navigate to="/tenantmgmt" replace />;
  }

  return (
    <>
      {isTenantScope && !isTenantUser ? <TenantContextBanner /> : null}
      <UserProfileManagement />
    </>
  );
};

export default UserProfilesPage;
